import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const MainContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  margin-top: 0;
  transition: all 0.3s ease;
`;

export const CertsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
  width: 100%;
  align-items: start;
`;

export const CertCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
  align-self: start;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const CertCardContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
`;

export const CertTitle = styled.div`
  margin: 0;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const EmployeeBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #64748B;
  font-size: 13px;
  margin-top: 4px;
`;

export const CountBadge = styled.div`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  background-color: ${COLORS.BACKGROUND_LIGHT};
  color: ${COLORS.PRIMARY};
  font-size: 13px;
  font-weight: 500;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
`;
